import request from '@/utils/request.js'
import { V3, TRIP_STATUS_ENDED } from '@/utils/config.js'


// Basic
export function getTrips(params) {
    return request({
        url: '/'+ V3 +'/trips',
        method: 'get',
        params,
    })
}

export function saveTrip(data) {
    return request({
        url: '/'+ V3 +'/trips',
        method: 'post',
        data,
    })
}

export function getTrip(id) {
    return request({
        url: '/'+ V3 +'/trips/' + id,
        method: 'get',
    })
}

export function updateTripStatus(ids, status) {
    return request({
        url: '/'+ V3 +'/trips/status',
        method: 'patch',
        data: {
            ids,
            status
        }
    })
}

export function endTrip(id) {
    return request({
        url: '/'+ V3 +'/trips/'+ id +'/status',
        method: 'patch',
        data: {
            trip_status: TRIP_STATUS_ENDED
        }
    })
}


// Settings
export function getTripSettings(id) {
    return request({
        url: '/'+ V3 +'/trips/' + id + '/settings',
        method: 'get',
    })
}


// Stops
export function getTripStops(id) {
    return request({
        url: '/'+ V3 +'/trips/' + id + '/stops',
        method: 'get',
        params: {
            size: -1
        }
    })
}


// Students
export function getScheduledStudents(id, params) {
    return request({
        url: '/'+ V3 +'/trips/' + id + '/sched-students',
        method: 'get',
        params: Object.assign({
            page: 1,
            size: -1,
        }, params)
    })
}

export function getUnScheduledStudents(id, params) {
    return request({
        url: '/'+ V3 +'/trips/' + id + '/unsched-students',
        method: 'get',
        params: Object.assign({
            page: 1,
            size: -1,
        }, params)
    })
}



// Manifest
export function getTripManifest(id) {
    return request({
        url: '/'+ V3 +'/trips/' + id + '/manifest',
        method: 'get',
    })
}


// Trip Logs
export function getTripLogs(id, params) {
    return request({
        url: '/'+ V3 +'/trips/' + id + '/logs',
        method: 'get',
        params
    })
}

// Direction
export function getTripDirections(id) {
    return request({
        url: '/'+ V3 +'/trips/' + id + '/directions',
        method: 'get',
    })
}

// Direction
export function getTripTracks(id, params) {
    return request({
        url: '/'+ V3 +'/trips/' + id + '/tracks',
        method: 'get',
        params
    })
}
